import React from "react";
import { useCountdown } from "_hooks/useCounddown";
import styles from "./countdown_timer.module.scss";

// const targetDate = "09/26/2022";

export const CountdownTimer = ({ targetDate, customClasses }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);
  const completed =
    parseInt(days) + parseInt(hours) + parseInt(minutes) + parseInt(seconds) <=
    0;

  return (
    <div
      className={`${styles.counter_wrapper} ${
        customClasses?.root ? customClasses?.root : ""
      }`}
    >
      <ul>
        <li>
          <div
            className={`${styles.counter_num} ${
              customClasses?.counter_number ? customClasses?.counter_number : ""
            }`}
          >
            {targetDate ? <>{completed ? "00" : days}</> : "00"}
          </div>
          <div
            className={`${styles.counter_txt} ${
              customClasses?.counter_text ? customClasses?.counter_text : ""
            }`}
          >
            Days
          </div>
        </li>
        <li>
          <div
            className={`${styles.counter_num} ${
              customClasses?.counter_number ? customClasses?.counter_number : ""
            }`}
          >
            {targetDate ? <>{completed ? "00" : hours}</> : "00"}
          </div>
          <div
            className={`${styles.counter_txt} ${
              customClasses?.counter_text ? customClasses?.counter_text : ""
            }`}
          >
            Hours
          </div>
        </li>
        <li>
          <div
            className={`${styles.counter_num} ${
              customClasses?.counter_number ? customClasses?.counter_number : ""
            }`}
          >
            {targetDate ? <>{completed ? "00" : minutes}</> : "00"}
          </div>
          <div
            className={`${styles.counter_txt} ${
              customClasses?.counter_text ? customClasses?.counter_text : ""
            }`}
          >
            Minutes
          </div>
        </li>
        <li>
          <div
            className={`${styles.counter_num} ${
              customClasses?.counter_number ? customClasses?.counter_number : ""
            }`}
          >
            {targetDate ? <>{completed ? "00" : seconds}</> : "00"}
          </div>
          <div
            className={`${styles.counter_txt} ${
              customClasses?.counter_text ? customClasses?.counter_text : ""
            }`}
          >
            Seconds
          </div>
        </li>
      </ul>
    </div>
  );
};

export default CountdownTimer;
